import type { UserGroupDataQualityListApiData, UserGroupDataQualityListApiResponses } from '@navio/nsdk';

import { apiUrl, dataEndpoint } from '../defineResource';

export const getUserGroupDataQualityUrls = {
  getUserGroupDataQuality: dataEndpoint<UserGroupDataQualityListApiData, UserGroupDataQualityListApiResponses>({
    getUrl: (queryParams) => apiUrl('user-groups/data-quality/', queryParams)
  })
};
